import React, {useEffect} from 'react'
import WOW from 'wowjs';
import 'animate.css';
import hoteldeals from '../../Assets/Images/deal-done-partnership-agreement-svgrepo-com.svg'
import yourimage from '../../Assets/Images/price-tag-svgrepo-com.svg'
import yourimg3 from '../../Assets/Images/magnifier-magnifying-glass-svgrepo-com.svg'
function Deal() {
   useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  return (
    <>
      <div className="container py-5">
  <div className="row text-center bg-light rounded-4 py-5">
    
    <div className="col-md-4 mb-4 mb-md-0 wow animate__animated animate__fadeInUp">
      <img src={hoteldeals} alt="Hotel Deals" className="mb-3" style={{width:'10em'}} />
      <h5 className="fw-bold">Great hotel deals</h5>
      <p className="text-muted mt-2">
        We search for deals with the world’s leading hotels,
        and share our findings with you.
      </p>
    </div>

    <div className="col-md-4 mb-4 mb-md-0 wow animate__animated animate__fadeInUp">
      <img src={yourimage} alt="Up-to-date pricing" className="mb-3" style={{width:'10em'}} />
      <h5 className="fw-bold">Up-to-date pricing</h5>
      <p className="text-muted mt-2">
        We always show you the most recent pricing overview we can find,
        so you know exactly what to expect.
      </p>
    </div>

    <div className="col-md-4 wow animate__animated animate__fadeInUp">
      <img src={yourimg3} alt="Precise searching" className="mb-3" style={{width:'10em'}} />
      <h5 className="fw-bold">Precise searching</h5>
      <p className="text-muted mt-2">
        Find hotels with swimming pools, free cancellation,
        and flexible booking. Or whatever matters most to you.
      </p>
    </div>

  </div>
</div>

    </>
  )
}

export default Deal
